import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  active: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    fontWeight: 500,
  },
  inactive: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontWeight: 500,
  },
}))

export default styles
